import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaOilReserves: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-oil-reserves-crisis.excalidraw"
    title="Australia's Oil & Fuel Reserves Crisis"
    subtitle="How the Israel-Iran war is threatening Australia's fuel security -- days of reserves left, price impacts, and downstream effects"
  />
);

export default AustraliaOilReserves;
